<ng-container *ngFor="let sectionTable of sectionData; let i = index">
    <table style="width: 100%" [ngClass]="{ 'aop-snapshot': isSnapshot }">
        <ng-container *ngFor="let row of sectionTable">
            <ng-container *ngIf="row.rowType === 'TableHead'">
                <thead>
                    <tr
                        [style.color]="tableHeaderColor"
                        class="big-row-min-height_plus-border-height black-border-down header"
                    >
                        <th class="title">{{ row.t }}</th>
                        <th class="value" [style.background-color]="backgroundColor" style="text-align: right">
                            {{ row.cV }}
                        </th>
                        <th
                            class="value"
                            *ngIf="!noPreviousData"
                            [style.background-color]="backgroundColorPY"
                            style="text-align: right"
                        >
                            {{ row.pV }}
                        </th>
                    </tr>
                </thead>
            </ng-container>

            <ng-container *ngIf="row.rowType === 'Row' || row.rowType === 'SubRow'">
                <tr [style.color]="textColor" class="row-min-height_plus-border-height gray-border-down">
                    <td class="title">
                        <span [ngClass]="row.rowType === 'SubRow' ? 'name-padding-left' : ''">{{ row.t }}</span>
                    </td>
                    <td
                        class="value"
                        [style.background-color]="backgroundColor"
                        style="text-align: right"
                        [ngClass]="{ 'current-year': isSnapshot }"
                    >
                        {{ row.cV }}
                    </td>
                    <td
                        class="value"
                        *ngIf="!noPreviousData"
                        [style.background-color]="backgroundColorPY"
                        [ngClass]="{ 'previous-year': isSnapshot }"
                        style="text-align: right"
                    >
                        {{ row.pV }}
                    </td>
                </tr>
            </ng-container>
            <ng-container *ngIf="row.rowType === 'GroupTotal' || row.rowType === 'TableTotal'">
                <tr
                    [style.color]="tableFooterColor"
                    [ngClass]="'reset-counter-' + (row.level == undefined ? 1 : row.level)"
                    [ngClass]="{
                        'snapshot-total-row': isSnapshot
                    }"
                    class="row-min-height_plus-border-height big-row-min-height_plus-border-height ng-star-inserted"
                >
                    <td class="title row-min-height black-border-down bolder-bigger big-row-min-height">
                        <span> {{ row.t }}</span>
                    </td>
                    <td
                        class="value black-border-down bolder-bigger big-row-min-height"
                        [style.background-color]="backgroundColor"
                        style="text-align: right"
                        [ngClass]="{ 'current-year': isSnapshot }"
                    >
                        {{ row.cV }}
                    </td>

                    <td
                        class="value black-border-down bolder-bigger big-row-min-height"
                        *ngIf="!noPreviousData"
                        [style.background-color]="backgroundColorPY"
                        [ngClass]="{ 'previous-year': isSnapshot }"
                        style="text-align: right"
                    >
                        {{ row.pV }}
                    </td>
                </tr>
            </ng-container>
        </ng-container>
    </table>
</ng-container>

<div class="section-description" *ngIf="description">
    <p [style.color]="textColor" [innerHtml]="description"></p>
</div>

<!-- CCR table (Capital Contribution Reserves) -->
<ng-container *ngIf="ccrSectionData">
    <table style="width: 100%" [ngClass]="{ 'aop-snapshot': isSnapshot }">
        <ng-container *ngFor="let row of ccrSectionData">
            <ng-container *ngIf="row.rowType === 'TableHead'">
                <thead>
                    <tr
                        [style.color]="tableHeaderColor"
                        class="big-row-min-height_plus-border-height black-border-down header"
                    >
                        <th class="title">{{ row.t }}</th>
                        <th class="value" [style.background-color]="backgroundColor" style="text-align: right">
                            {{ row.cV }}
                        </th>
                        <th
                            class="value"
                            *ngIf="!noPreviousData"
                            [style.background-color]="backgroundColorPY"
                            style="text-align: right"
                        >
                            {{ row.pV }}
                        </th>
                    </tr>
                </thead>
            </ng-container>

            <ng-container *ngIf="row.rowType === 'Row'">
                <tr [style.color]="textColor" class="row-min-height_plus-border-height gray-border-down">
                    <td class="title"><span>{{ row.t }}</span></td>
                    <td
                        class="value"
                        [style.background-color]="backgroundColor"
                        style="text-align: right"
                        [ngClass]="{ 'current-year': isSnapshot }"
                    >
                        {{ row.cV }}
                    </td>
                    <td
                        class="value"
                        *ngIf="!noPreviousData"
                        [style.background-color]="backgroundColorPY"
                        [ngClass]="{ 'previous-year': isSnapshot }"
                        style="text-align: right"
                    >
                        {{ row.pV }}
                    </td>
                </tr>
            </ng-container>

            <ng-container *ngIf="row.rowType === 'TableTotal'">
                <tr
                    [style.color]="tableFooterColor"
                    [ngClass]="{ 'snapshot-total-row': isSnapshot }"
                    class="row-min-height_plus-border-height big-row-min-height_plus-border-height ng-star-inserted"
                >
                    <td class="title row-min-height black-border-down bolder-bigger big-row-min-height">
                        <span>{{ row.t }}</span>
                    </td>
                    <td
                        class="value black-border-down bolder-bigger big-row-min-height"
                        [style.background-color]="backgroundColor"
                        style="text-align: right"
                        [ngClass]="{ 'current-year': isSnapshot }"
                    >
                        {{ row.cV }}
                    </td>
                    <td
                        class="value black-border-down bolder-bigger big-row-min-height"
                        *ngIf="!noPreviousData"
                        [style.background-color]="backgroundColorPY"
                        [ngClass]="{ 'previous-year': isSnapshot }"
                        style="text-align: right"
                    >
                        {{ row.pV }}
                    </td>
                </tr>
            </ng-container>
        </ng-container>
    </table>
</ng-container>

<div class="section-description" *ngIf="ccrFootnote">
    <p [style.color]="textColor" [innerHtml]="ccrFootnote"></p>
</div>
